import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import themes from "~/themes";
import * as S from "./styles";

const InputOnboarding = ({
  marginBottom,
  error,
  mask,
  label,
  defaultValue,
  onChange,
  icon = false,
  largeLabel,
  largeBorder,
  ...rest
}) => {
  const [focusInput, setFocusInput] = useState(false);
  const [showText, setShowText] = useState(false);

  return (
    <S.Container
      marginBottom={marginBottom}
      isFocus={focusInput}
      largeLabel={largeLabel}
    >
      <label>{label}</label>

      <input
        type={icon ? (showText ? "text" : "password") : "text"}
        onFocus={() => setFocusInput(true)}
        onBlur={() => setFocusInput(false)}
        className={`${largeBorder ? "large-border" : ""}`}
        style={{ borderColor: `${error ? "#E71037" : ""}` }}
        mask={mask}
        defaultValue={defaultValue}
        onError={error}
        onChange={onChange}
        {...rest}
      />
      {icon ? (
        showText ? (
          <img
            src={themes.components.images.visible}
            onClick={() => setShowText(!showText)}
            className="icon"
            style={{ marginTop: 20 }}
          />
        ) : (
          <img
            src={themes.components.images.invisible}
            onClick={() => setShowText(!showText)}
            className="icon"
            style={{ marginTop: 18 }}
          />
        )
      ) : null}

      {!!error && <S.ErrorText>{error}</S.ErrorText>}
    </S.Container>
  );
};

export default InputOnboarding;
